import { Pages, Page } from "./pagesTypes";
import { Record } from "immutable";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const defaultValues: Pages = {
  active: null,
  list: [],
};

class State extends Record(defaultValues) {
  constructor(params: Pages) {
    super(params);
  }
}

const initialState: State = new State(defaultValues);

export const pagesSlice = createSlice({
  name: "pages",
  initialState,
  reducers: {
    UPDATE_WEBPAGES: (state, action: PayloadAction<Pages["list"]>) => {
      return state.setIn(["list"], action.payload);
    },
    UPDATE_WEBPAGE: (
      state: any,
      action: PayloadAction<{
        uuid: string;
        data: Page;
      }>
    ) => {
      const list = state.get("list") as Page[];
      const index = list.findIndex(
        (x: Page) => x.uuid === action.payload.uuid
      );
      if (index < 0) {
        return state;
      }
      return state.setIn(["list", index], action.payload.data);
    },
    DELETE_WEBPAGE: (state: any, action: PayloadAction<{ uuid: string }>) => {
      const list = state.get("list") as Page[];
      const index = list.findIndex(
        (x: Page) => x.uuid === action.payload.uuid
      );
      if (index < 0) {
        return state;
      }
      return state.removeIn(["list", index]);
    },
    ADD_WEBPAGE: (state: any, action: PayloadAction<Page>) => {
      const list = state.get("list") as Page[];
      const index = list.findIndex(
        (x: Page) => x.id === 0 || x.uuid === ""
      );
      if (index < 0) {
        return state.setIn(["list"], [...list, action.payload]);
      }
      return state.setIn(["list", index], action.payload);
    },
    SET_WEBPAGE_ACTIVE: (state: any, action: PayloadAction<Pages["active"]>) => {
      return state.setIn(["active"], action.payload);
    },
  },
});

export const {
  UPDATE_WEBPAGES,
  UPDATE_WEBPAGE,
  DELETE_WEBPAGE,
  ADD_WEBPAGE,
  SET_WEBPAGE_ACTIVE,
} = pagesSlice.actions;

export default pagesSlice.reducer;
